import {useContext} from 'react'
import Header from '../components/general/Header'
import Footer from '../components/general/Footer'
import ContenidoInicio from '../components/inicio/ContenidoInicio.jsx'
import MetaData from '../context/MetaData'

export default function Inicio(){
    return(
        <div>         
            <MetaData titulo="Bienvenidos"/>
            <Header>            
            </Header>
            <ContenidoInicio></ContenidoInicio>
            <Footer></Footer>
        </div>
    );
}
